/*
 * EB Cart State — fuente única de verdad del carrito.
 * Hidrata desde Liquid (window.EB_CART_INITIAL), escucha cart:update, refresca con bfcache.
 * Suscriptores: progress bar, gift reconciler, sticky CTA.
 */
(function () {
  if (window.EBCart) return;

  /** @type {Set<(state: object, source: string) => void>} */
  const subscribers = new Set();

  let state = {
    item_count: 0,
    items: [],
    items_subtotal_price: 0,
    total_price: 0,
    currency: 'EUR',
    hydrated: false,
  };

  function notify(source) {
    subscribers.forEach((fn) => {
      try { fn(state, source); } catch (e) { /* swallow */ }
    });
  }

  function setState(patch, source) {
    state = Object.assign({}, state, patch, { hydrated: true });
    notify(source || 'set');
  }

  async function fetchCart(source) {
    try {
      const res = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) return;
      const data = await res.json();
      setState({
        item_count: data.item_count,
        items: data.items || [],
        items_subtotal_price: data.items_subtotal_price ?? data.total_price ?? 0,
        total_price: data.total_price,
        currency: data.currency,
      }, source || 'fetch');
      return data;
    } catch (_e) {
      /* network: keep last state */
    }
  }

  if (window.EB_CART_INITIAL) {
    setState(window.EB_CART_INITIAL, 'liquid-initial');
  }

  document.addEventListener('cart:update', (event) => {
    const detail = event && event.detail;
    if (!detail) return;
    const resource = detail.resource;
    const meta = detail.data || {};

    if (resource && typeof resource === 'object' && 'item_count' in resource) {
      setState({
        item_count: resource.item_count,
        items: resource.items || state.items,
        items_subtotal_price: resource.items_subtotal_price ?? resource.total_price ?? state.items_subtotal_price,
        total_price: resource.total_price ?? state.total_price,
        currency: resource.currency || state.currency,
      }, meta.source || 'cart:update');
    } else {
      // resource missing or partial — refetch to stay accurate
      fetchCart(meta.source || 'cart:update-fallback');
    }
  });

  document.addEventListener('cart:error', () => fetchCart('cart:error'));

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) fetchCart('pageshow-bfcache');
  });

  window.EBCart = {
    get state() { return state; },
    subscribe(fn) {
      subscribers.add(fn);
      if (state.hydrated) {
        try { fn(state, 'subscribe'); } catch (_e) { /* swallow */ }
      }
      return () => subscribers.delete(fn);
    },
    refresh(source) { return fetchCart(source); },
    /** Permite a otros módulos publicar un nuevo estado (ej. el gift reconciler tras /cart/update.js). */
    push(patch, source) { setState(patch, source); },
  };

  if (!state.hydrated) {
    setTimeout(() => { if (!state.hydrated) fetchCart('boot'); }, 60);
  }
})();
